import { createApp } from 'vue'
import SpotCard from './SpotCard'

const el = '.kb-component--spot-card'
const DOMs = document.querySelectorAll(el)

export default function (Store) {
    if (DOMs && DOMs.length) {
        DOMs.forEach((SpotCardDOM) => {
            const spotCardData = SpotCardDOM.dataset.spotCard
                ? JSON.parse(SpotCardDOM.dataset.spotCard)
                : null
            const component = createApp(SpotCard, { spotCardData }).use(
                Store
            )
            component.mount(SpotCardDOM)
        })
    }
}
